import api from "../api/axios";

export const initiatePayment = async (paymentData) => {
    try {
        const response = await api.post(
            "/api/phonepe/payment-initiate",
            paymentData
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message || error.message || "Failed to initiate payment"
        );
    }
};

export const generatePaymentToken = async (paymentData) => {
    try {
        const response = await api.post(
            "/api/phonepe/generate-payment-token",
            paymentData
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message || error.message || "Failed to initiate payment"
        );
    }
};

export const checkPaymentStatus = async (token) => {
    try {
        const response = await api.get(`/api/phonepe/status/${token}`);
        return response.data;
    } catch (error) {
        throw new Error(
            error?.response?.data?.message || error.message || "Failed to check payment status"
        );
    }
};


